import {
  PageHeader,
  Loading,
  toastSuccessMessage,
  updateUserCurrentStep,
  downloadFileFromResponse,
} from "wup-module1-base";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import SiteQuestions from "../SiteQuestions/SiteQuestions";
import { useForm } from "react-hook-form";
import { Form, Card, Row, Col, Button, Container } from "react-bootstrap";
import { useState, useContext, useEffect, useRef, useCallback } from "react";
import { PageTitleConstants, QuestionnairesEnum } from "../../Constants";
import UserContext from "../../Contexts/UserContext";
import { SurveyService, ClientService, AuthService } from "../../Services";
import { M1_FormApplicationStatuses } from "../../Constants";

function Survey() {
  const [surveyData, setSurveyData] = useState(null);
  const { user, setUser } = useContext(UserContext);
  const [surveyAnswersData, setSurveyAnswersData] = useState(null);
  const [isFinal, setIsFinal] = useState(false);
  const [userCurrentPage, setUserCurrentPage] = useState(1);
  const [areasHelper, setAreasHelper] = useState();
  const survType = 1;
  const {
    register,
    getValues,
    setValue,
    handleSubmit,
    reset,
    trigger,
    unregister,
    watch,
    setError,
    clearErrors,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
  });
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [answers, setAnswers] = useState({});
  const [surveyId, setSurveyId] = useState(null);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isSubmitAvailable, setIsSubmitAvailable] = useState(false);
  const saveDataWithIntervalsRef = useRef();

  function onSubmit() {
    if (!!!isSubmitAvailable) return;
    setIsSubmitLoading(true);
    const rawAnswersObj = {
      tasks: JSON.stringify(areasHelper)
    }
    const requestData = {
      questionnaire_id: surveyId,
      client_id: user.id,
      answers: JSON.stringify(setNewIndexForTable(getValues())),
      final: true,
      complete_answers: getAnswersCount().toString(),
      complete_pages: userCurrentPage.toString(),
      raw_answers_data: JSON.stringify(rawAnswersObj),
    };

    SurveyService.storeSurvey(requestData, user.id, surveyId)
      .then((response) => {
        fetchUserData();
        navigate(`/`);
        toastSuccessMessage("Dane przesłane pomyślnie");
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsSubmitLoading(false);
      });
  }

  const fetchUserData = () => {
    AuthService.getUserData()
      .then((response) => {
        const updatedUser = updateUserCurrentStep(
          user,
          response.data.status,
          response.data.clientStep
        );
        setUser(updatedUser);
      })
      .catch((error) => { });
  };

  //funkcja pobierająca pdf
  const downloadPDF = () => {
    SurveyService.downloadAnswersPDF(user.id, surveyId)
      .then((res) => {
        downloadFileFromResponse(res);
        toastSuccessMessage("Pobieranie pliku");
      })
      .catch((error) => {
        toast.error("Błąd pobrania PDF");
      });
  };

  //funkcja zwracajaca na ile pytan uzytkownik udzielil odpowiedzi
  const getAnswersCount = () => {
    let answeredQuestions = 0;
    let answeredQuestionIds = new Set();
    let data = getValues();
    for (const key in data) {
      if (key.includes("_")) {
        const questionId = key.split("_")[0];
        if (!answeredQuestionIds.has(questionId) && data[key] !== "") {
          answeredQuestions++;
          answeredQuestionIds.add(questionId);
        }
      }
    }
    for (const key in data) {
      if (!key.includes("_") && data[key] !== "") {
        answeredQuestions++;
      }
    }

    return answeredQuestions;
  };

  //funkca ktora ustawia klienta jako uczestnika projektu
  function setClientStatusAsProjectMember() {
    ClientService.patchClientEnity(
      user.id,
      M1_FormApplicationStatuses.ProjectMember.value
    )
      .then((response) => {})
      .catch((error) => {
        console.error(error);
      });
  }

  //pomocnicza funkcja reindeksująca tworząca jedną tablice dla tabel która wstawiamy do odpowiedzi
  function setDataToUpdate(data) {
    let table = [];
    for (let key in data) {
      for (let subKey in data[key]) {
        let index = subKey;
        let valueKeys = Object.keys(data[key][subKey]);
        for (let i = 0; i < valueKeys.length; i++) {
          let valueKey = valueKeys[i];
          let parts = valueKey.split("_");
          parts[parts.length - 1] = index;
          let newKey = parts.join("_");
          data[key][subKey][newKey] = data[key][subKey][valueKey];
          if (newKey !== valueKey) {
            delete data[key][subKey][valueKey];
          }
        }
        table.push(data[key][subKey]);
      }
    }

    const obj = table.reduce((acc, curr) => {
      return { ...acc, ...curr };
    }, {});

    return obj;
  }

  //funkcja reindeksujaca czyści stare klucze i ustawia nowe
  function setNewIndexForTable(daxta) {
    let data = getValues();
    for (const key in data) {
      if (key.startsWith("answer")) {
        delete data[key];
      }
      if (key.endsWith("table_0")) {
        delete data[key];
      }
    }

    const groupedData = {};

    for (const key in data) {
      if (key.split("_").length === 3) {
        const [selector, , lastIndexValue] = key.split("_");
        groupedData[selector] = groupedData[selector] || {};
        groupedData[selector][lastIndexValue] = {
          ...groupedData[selector][lastIndexValue],
          [key]: data[key],
        };
        delete data[key];
      }
    }

    const reindexedObject = {};

    for (const [key, value] of Object.entries(groupedData)) {
      reindexedObject[key] = {};
      let index = 1;
      for (const innerValue of Object.values(value)) {
        reindexedObject[key][index] = innerValue;
        index++;
      }
    }
    const updatedData = setDataToUpdate(reindexedObject);

    return { ...data, ...updatedData };
  }

  const saveDataWithIntervals = useCallback(() => {
    const rawAnswersObj = {
      tasks: JSON.stringify(areasHelper)
    };
    const requestData = {
      questionnaire_id: surveyId,
      client_id: user.id,
      answers: JSON.stringify(setNewIndexForTable(getValues())),
      final: false,
      complete_answers: getAnswersCount().toString(),
      complete_pages: userCurrentPage.toString(),
      raw_answers_data: JSON.stringify(rawAnswersObj),
    };
    SurveyService.storeSurvey(requestData, user.id, surveyId)
      .then((response) => {
      })
      .catch((error) => {
        console.error(error);
      });
  }, [areasHelper, surveyId, user.id, getValues, getAnswersCount, userCurrentPage, SurveyService]);

    useEffect(() => {
      saveDataWithIntervalsRef.current = saveDataWithIntervals;
    }, [saveDataWithIntervals]);

  const fetchData = () => {
    SurveyService.fetchSurvey(surveyId)
      .then((response) => {
        setSurveyData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const fetchAnswersData = () => {
    SurveyService.fetchAnswers(user.id, surveyId)
      .then((response) => {
        setSurveyAnswersData(response.data.answers);
        setIsFinal(response.data.final);
        if (response.data.complete_pages) {
          setUserCurrentPage(parseInt(response.data.complete_pages));
        } else {
          setUserCurrentPage(1);
        }
      })
      .catch((error) => {
        setClientStatusAsProjectMember();
        setUserCurrentPage(1);
        saveDataWithIntervalsRef.current();
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      saveDataWithIntervalsRef.current();
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    reset(JSON.parse(surveyAnswersData));
  }, [surveyAnswersData]);

  useEffect(() => {
    if (!isFinal && surveyId != null) {
      const interval = setInterval(() => {
        saveDataWithIntervalsRef.current();
      }, 60000);

      return () => clearInterval(interval);
    }
  }, [isFinal, surveyId, userCurrentPage]);

  useEffect(() => {
    if (surveyData) fetchAnswersData();
  }, [surveyData]);

  useEffect(() => {
    if (surveyId) fetchData();
  }, [surveyId]);

  useEffect(() => {
    SurveyService.fetchTypes()
      .then((response) => {
        const survey = response.data.find(
          (s) => s.type === QuestionnairesEnum.First.value
        );
        if (!!survey) setSurveyId(survey.id);
        else toast.error("Brak ankiet");
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Container>
        <PageHeader content={PageTitleConstants.Autoanalysis} />
        <Form onSubmit={handleSubmit(onSubmit)}>
          {!!isLoading || !userCurrentPage ? (
            <Loading />
          ) : (
            surveyData && (
              <Row className="mt-1">
                <SiteQuestions
                  surveyArray={surveyData.pages}
                  register={register}
                  getValues={getValues}
                  answers={answers}
                  setAnswers={setAnswers}
                  errors={errors}
                  trigger={trigger}
                  unregister={unregister}
                  watch={watch}
                  setValue={setValue}
                  surveyAnswersData={surveyAnswersData}
                  isFinal={isFinal}
                  downloadPDF={downloadPDF}
                  isValid={isValid}
                  setUserCurrentPage={setUserCurrentPage}
                  userCurrentPage={userCurrentPage}
                  setError={setError}
                  clearErrors={clearErrors}
                  saveDataWithIntervals={saveDataWithIntervalsRef.current}
                  survType={survType}
                  reset={reset}
                  isSubmitLoading={isSubmitLoading}
                  setAreasHelper={setAreasHelper}
                  isSubmitAvailable={isSubmitAvailable}
                  setIsSubmitAvailable={setIsSubmitAvailable}
                />
              </Row>
            )
          )}
        </Form>
      </Container>
    </>
  );
}

export default Survey;
